import { useState } from 'react';

export default function Products() {
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  const products = [
    {
      id: 1,
      name: 'Warlord Battle Staff',
      category: 'FEATURED WEAPON',
      price: 349.99,
      dimensions: '72" x 4"',
      weight: '4.8 lbs',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/6b47e1d815f97a623df2f7cac97369ac.jpeg',
      description: 'Our flagship weapon. Hand-carved from solid hardwood with reinforced striking ends. Perfect balance for training or display.',
      featured: true
    },
    {
      id: 2,
      name: 'Corn Knife',
      price: 29.99,
      dimensions: '24.25" x 2"',
      weight: '12 oz',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/492a25c684edb47316be7435847c1f5b.jpeg',
      description: 'Compact and razor-sharp. Traditional corn knife design with a sturdy blade. Built for serious collectors.'
    },
    {
      id: 3,
      name: 'Nordic Pick Hammer',
      price: 29.99,
      dimensions: '12.75" x 7.25"',
      weight: '1.5 lbs',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/e5150c285cf487dfe1c0bcdd9a68f18f.jpeg',
      description: 'Versatile and reliable. Nordic-inspired pick hammer with contoured grip. Ideal for collectors and display.'
    },
    {
      id: 4,
      name: 'Machete',
      price: 29.99,
      dimensions: '12.75" x 7.25"',
      weight: '1.5 lbs',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/8cb2c94720b3710bf0975218d71467f8.jpeg',
      description: 'Heavy-duty cutting tool. Weighted blade for powerful strokes. Traditional design meets modern durability.'
    },
    {
      id: 5,
      name: 'Coal Pick',
      price: 39.99,
      dimensions: '21" x 11"',
      weight: '2 lbs',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/d17e6e2eafb737713bdc9e4f50a9ab70.jpeg',
      description: 'Rugged and functional. Solid construction with comfortable grip. Perfect for collectors or display.'
    },
    {
      id: 6,
      name: 'Harvester Blade',
      price: 79.99,
      dimensions: '52.25" x 11.25"',
      weight: '3.5 lbs',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/6b47e1d815f97a623df2f7cac97369ac.jpeg',
      description: 'Classic warrior design. Long curved blade profile with wrapped handle. A true collector\'s piece.'
    },
    {
      id: 7,
      name: 'Saw Axe',
      price: 79.99,
      dimensions: '41" x 11.6"',
      weight: '5 lbs',
      status: 'IN STOCK',
      image: 'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/bb14c091da64d9e9a6fdc72b8ce30512.jpeg',
      description: 'Masterfully crafted saw axe with brass circular blade. Hand-carved details and symbols. A true warrior\'s companion combining ancient tradition with deadly precision.'
    }
  ];

  const featuredProduct = products.find(p => p.featured);
  const standardProducts = products.filter(p => !p.featured);

  return (
    <section id="products" className="bg-[#0f1419] py-16 sm:py-24 lg:py-32 px-4 sm:px-8 relative">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12 sm:mb-16 gap-6">
          <h2 className="text-[40px] sm:text-[56px] lg:text-[68px] font-serif text-[#F7F7F7] leading-none">THE ARSENAL</h2>
          <p className="text-sm sm:text-base text-[#718096] max-w-[420px] leading-relaxed">
            Each weapon in our collection is handcrafted with precision and purpose. Browse our arsenal of battle-ready tools designed for collectors, warriors, and those who value preparedness.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-7" data-product-shop>
          {/* Featured Product - Left Column */}
          {featuredProduct && (
            <div className="lg:row-span-2 bg-[#1a202c] rounded-2xl sm:rounded-3xl overflow-hidden group hover:transform hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="p-4 sm:p-6">
                <span className="inline-block text-[10px] sm:text-xs uppercase tracking-widest text-white bg-[#8B6914] px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4">
                  {featuredProduct.category}
                </span>
              </div>
              
              <div className="px-4 sm:px-6 pb-4 sm:pb-6 h-[350px] sm:h-[450px] lg:h-[500px] flex items-center justify-center bg-black">
                <img
                  src={featuredProduct.image}
                  alt={featuredProduct.name}
                  className="w-full h-full object-contain object-center"
                />
              </div>

              <div className="p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-[#F7F7F7] mb-3">{featuredProduct.name}</h3>
                <p className="text-sm sm:text-base text-[#718096] mb-4 leading-relaxed">{featuredProduct.description}</p>
                <div className="flex items-center gap-3 sm:gap-4 text-xs sm:text-sm text-[#718096] mb-6">
                  <span>{featuredProduct.dimensions}</span>
                  <span>|</span>
                  <span>{featuredProduct.weight}</span>
                </div>
                <div className="text-2xl sm:text-3xl font-bold text-[#8B6914] mb-6">${featuredProduct.price}</div>
                <button className="w-full bg-transparent border-2 border-[#8B6914] text-[#8B6914] py-3 sm:py-4 rounded-xl font-bold hover:bg-[#8B6914] hover:text-white transition-all whitespace-nowrap">
                  VIEW DETAILS
                </button>
              </div>
            </div>
          )}

          {/* Standard Products - Right Columns */}
          {standardProducts.map((product) => (
            <div
              key={product.id}
              className="bg-[#2d3748] rounded-2xl sm:rounded-3xl overflow-hidden group hover:transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
            >
              <div className="p-3 sm:p-4">
                <span className="inline-flex items-center gap-2 text-[10px] sm:text-xs uppercase tracking-wide text-green-400">
                  <span className="w-2 h-2 bg-green-400 rounded-full"></span>
                  {product.status}
                </span>
              </div>

              <div className="px-4 sm:px-6 pb-4 sm:pb-6 h-[220px] sm:h-[260px] lg:h-[280px] flex items-center justify-center bg-black">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain object-center"
                />
              </div>

              <div className="p-4 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-[#F7F7F7] mb-2">{product.name}</h3>
                <div className="flex items-center gap-2 sm:gap-3 text-xs sm:text-sm text-[#718096] mb-3">
                  <span>{product.dimensions}</span>
                  <span>|</span>
                  <span>{product.weight}</span>
                </div>
                <div className="text-xl sm:text-2xl font-bold text-[#8B6914] mb-4">${product.price}</div>
                <button className="w-full bg-[#8B6914] text-white py-3 rounded-full font-bold hover:bg-[#6B4423] transition-all whitespace-nowrap text-sm sm:text-base">
                  ADD TO CART
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
